import { LyftDispatchRideReceipt } from './lyft-dispatch-ride-receipt';
import { autoserialize, autoserializeAs } from 'cerialize';

export class LyftDispatchRideSummary {
  @autoserialize
  reservationId: number;

  @autoserialize
  rideRequestId: number;

  @autoserialize
  lyftRideId: string;

  @autoserialize
  driverMessage: string;

  @autoserialize
  status: string;

  @autoserialize
  driverName: string;

  @autoserialize
  vehicleMake: string;

  @autoserialize
  vehicleModel: string;

  @autoserialize
  vehicleYear: string;

  @autoserialize
  vehicleColor: string;

  @autoserialize
  licensePlateNumber: string;

  @autoserialize
  licensePlateState: string;

  @autoserialize
  externalMemo: string;

  @autoserialize
  distance: number;

  @autoserialize
  duration: number;

  @autoserializeAs(LyftDispatchRideReceipt)
  lyftDispatchRideReceipt: LyftDispatchRideReceipt;

  @autoserialize
  routeUrl: string;

  @autoserialize
  createdByUserId: number;
}
